import React from 'react'
import "./Loader.css"
export default function Loader() {
  return (
    <div className='Loader-component'>
     <div class="loader"></div>
    </div>
    
  )
}
